"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CondominiumService = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Api = _interopRequireDefault(require("../Api"));
var _excluded = ["token", "path", "op"],
  _excluded2 = ["token", "id"],
  _excluded3 = ["token", "id"],
  _excluded4 = ["token", "condoId", "userId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CondominiumService = exports.CondominiumService = /*#__PURE__*/(0, _createClass2["default"])(function CondominiumService() {
  (0, _classCallCheck2["default"])(this, CondominiumService);
});
(0, _defineProperty2["default"])(CondominiumService, "editCondo", function (_ref) {
  var token = _ref.token,
    path = _ref.path,
    _ref$op = _ref.op,
    op = _ref$op === void 0 ? 'edit' : _ref$op,
    params = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return _Api["default"].withAuth(token).post("/condo/".concat(op, "/").concat(path), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(CondominiumService, "editCondoConfiguration", function (_ref2) {
  var token = _ref2.token,
    id = _ref2.id,
    params = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return _Api["default"].withAuth(token).patch("/condo/".concat(id, "/configuration"), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(CondominiumService, "getCondo", function (_ref3) {
  var token = _ref3.token,
    id = _ref3.id,
    params = (0, _objectWithoutProperties2["default"])(_ref3, _excluded3);
  return _Api["default"].withAuth(token).get("/condo/".concat(id), {
    params: params
  });
});
(0, _defineProperty2["default"])(CondominiumService, "removeAdminFromCondo", function (_ref4) {
  var token = _ref4.token,
    condoId = _ref4.condoId,
    userId = _ref4.userId,
    params = (0, _objectWithoutProperties2["default"])(_ref4, _excluded4);
  return _Api["default"].withAuth(token).post("/condo/".concat(condoId, "/remove/admin/").concat(userId), _objectSpread({}, params));
});